import { ChatMessage, ChatMessageCreateRequest, ChatType, UserChat } from 'interfaces/UserChat'
import ApiService from './ApiService'
import { User } from 'interfaces/User'

const UserChatService = {
    list(userUuid: string, page?: number, listUnreadChats?: boolean, type?: ChatType) {
        return ApiService.get(
            `users/${userUuid}/chats${
                page || page === 0
                    ? `?page=${page}&limit=${listUnreadChats ? 100 : 20}${
                          listUnreadChats ? `&listUnread=${listUnreadChats}` : ''
                      }${type ? `&type=${type}` : ''}`
                    : ''
            }`
        ).then((response) => {
            return {
                chats: response.data.content as UserChat[],
                page: response.data.number as number,
                totalPages: response.data.totalPages as number,
                hasMorePages: !response.data.last,
            }
        })
    },

    get(userUuid: string) {
        return ApiService.get(`users/${userUuid}/chat`).then((response) => {
            return response.data as UserChat
        })
    },

    getChat(uuid: string) {
        return ApiService.get(`chats/${uuid}`).then((response) => {
            return response.data as UserChat
        })
    },

    getChatMessages(uuid: string, cursor?: string) {
        return ApiService.get(`chats/${uuid}/messages${cursor ? `?cursor=${cursor}` : ''}`).then((response) => {
            return {
                messages: response.data.content as ChatMessage[],
                nextCursor: response.data.nextCursor as string,
            }
        })
    },

    postMessage(uuid: string, message: ChatMessageCreateRequest) {
        return ApiService.post(`chats/${uuid}/messages`, message).then((response) => {
            return response.data as ChatMessage
        })
    },

    getChatByUser(userUuid: string) {
        return ApiService.get(`users/${userUuid}/chat`).then((response) => {
            return {
                isNew: response.status === 201,
                chat: response.data as UserChat,
            }
        })
    },

    markChatAsRead(uuid: string) {
        return ApiService.post(`chats/${uuid}/markasread`).then((response) => {
            return response.data
        })
    },

    deleteChat(uuid: string) {
        return ApiService.delete(`chats/${uuid}`).then((response) => {
            return response.data
        })
    },

    getChatMembers(uuid: string) {
        return ApiService.get(`chats/${uuid}/users`).then((response) => {
            return {
                users: response.data.content as User[],
                totalUsers: response.data.totalElements,
            }
        })
    },

    getThreadMessages(chatUuid: string, messageUuid: string) {
        return ApiService.get(`chats/${chatUuid}/messages/${messageUuid}/thread-messages`).then((response) => {
            return response.data.content as ChatMessage[]
        })
    },

    joinGroupChat(chatUuid: string) {
        return ApiService.post(`chats/${chatUuid}/users`).then((response) => {
            return response.data as ChatMessage
        })
    },
}

export default UserChatService
